import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.string.trim.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "etiquetas-page"
  }, [_c('div', {
    staticClass: "etiquetas-header"
  }, [_vm._m(0), _c('button', {
    staticClass: "btn btn-primary font-weight-bold",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.openCreateModal();
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-plus mr-2"
  }), _vm._v("Nova etiqueta ")])]), _vm.loading ? _c('div', {
    staticClass: "loading-state"
  }, [_c('div', {
    staticClass: "spinner spinner-primary spinner-lg"
  }), _c('span', [_vm._v("Carregando modelos com segurança...")])]) : [_c('div', {
    staticClass: "catalog-card"
  }, [_c('div', {
    staticClass: "catalog-toolbar"
  }, [_c('div', {
    staticClass: "catalog-tabs",
    attrs: {
      "role": "tablist",
      "aria-label": "Filtrar modelos"
    }
  }, [_c('button', {
    class: {
      active: _vm.tab === 'todos'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        _vm.tab = 'todos';
      }
    }
  }, [_vm._v(" Todos ")]), _c('button', {
    class: {
      active: _vm.tab === 'editor'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        _vm.tab = 'editor';
      }
    }
  }, [_vm._v(" Criados no editor ")]), _c('button', {
    class: {
      active: _vm.tab === 'legados'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        _vm.tab = 'legados';
      }
    }
  }, [_vm._v(" Legados ")]), _c('button', {
    class: {
      active: _vm.tab === 'rascunhos'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        _vm.tab = 'rascunhos';
      }
    }
  }, [_vm._v(" Rascunhos ")])]), _c('div', {
    staticClass: "catalog-search input-icon"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: _vm.search,
      expression: "search",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "search",
      "placeholder": "Buscar por nome ou código"
    },
    domProps: {
      "value": _vm.search
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.search = $event.target.value.trim();
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  }), _vm._m(1)])]), _vm.showNewSection ? _c('div', {
    staticClass: "catalog-section"
  }, [_c('div', {
    staticClass: "section-heading"
  }, [_vm._m(2), _c('span', [_vm._v(_vm._s(_vm.filteredNew.length) + " encontrado" + _vm._s(_vm.filteredNew.length === 1 ? "" : "s"))])]), _vm.filteredNew.length ? _c('div', {
    staticClass: "new-model-grid"
  }, _vm._l(_vm.filteredNew, function (model) {
    return _c('article', {
      key: model.uuid,
      staticClass: "model-card"
    }, [_c('div', {
      staticClass: "model-card-top"
    }, [_c('span', {
      class: ['model-symbol', model.tem_publicacao ? 'published' : 'draft']
    }, [_c('i', {
      class: model.tem_publicacao ? 'fas fa-tag' : 'fas fa-pencil-alt'
    })]), _c('span', {
      class: ['state-pill', model.tem_publicacao ? 'published' : 'draft']
    }, [_c('i'), _vm._v(_vm._s(model.tem_publicacao ? "Publicado" : "Rascunho") + " ")]), _c('b-dropdown', {
      attrs: {
        "right": "",
        "no-caret": "",
        "size": "sm",
        "variant": "link",
        "toggle-class": "model-menu",
        "menu-class": "shadow-sm"
      },
      scopedSlots: _vm._u([{
        key: "button-content",
        fn: function fn() {
          return [_c('i', {
            staticClass: "fas fa-ellipsis-v"
          })];
        },
        proxy: true
      }], null, true)
    }, [_c('b-dropdown-item', {
      on: {
        "click": function click($event) {
          return _vm.duplicateModel(model);
        }
      }
    }, [_c('i', {
      staticClass: "far fa-copy mr-2"
    }), _vm._v("Duplicar")]), model.tem_rascunho ? _c('b-dropdown-item', {
      staticClass: "text-danger",
      on: {
        "click": function click($event) {
          return _vm.discardDraft(model);
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-undo-alt mr-2"
    }), _vm._v(_vm._s(_vm.discardDraftLabel(model)))]) : _vm._e(), _c('b-dropdown-divider'), _c('b-dropdown-item', {
      staticClass: "text-danger",
      on: {
        "click": function click($event) {
          return _vm.archiveModel(model);
        }
      }
    }, [_c('i', {
      staticClass: "far fa-trash-alt mr-2"
    }), _vm._v("Arquivar")])], 1)], 1), _c('h6', {
      attrs: {
        "title": model.nome
      }
    }, [_vm._v(_vm._s(model.nome))]), _c('p', [_vm._v(_vm._s(model.descricao || "Modelo visual de etiqueta."))]), _c('div', {
      staticClass: "model-meta"
    }, [_c('span', [_c('i', {
      staticClass: "fas fa-building"
    }), _vm._v(_vm._s(_vm.scopeLabel(model)))]), _c('span', [_c('i', {
      staticClass: "fas fa-history"
    }), _vm._v(_vm._s(_vm.versionLabel(model)))])]), _c('button', {
      staticClass: "btn btn-sm btn-light-primary btn-block font-weight-bold",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.editModel(model);
        }
      }
    }, [_vm._v(" " + _vm._s(model.tem_rascunho ? "Continuar edição" : "Criar nova versão") + " "), _c('i', {
      staticClass: "fas fa-arrow-right ml-2"
    })]), model.tem_rascunho ? _c('button', {
      staticClass: "draft-discard-action btn btn-sm btn-light-danger btn-block font-weight-bold mt-2",
      class: {
        'spinner spinner-danger spinner-right': _vm.discardingUuid === model.uuid
      },
      attrs: {
        "type": "button",
        "disabled": _vm.discardingUuid === model.uuid
      },
      on: {
        "click": function click($event) {
          return _vm.discardDraft(model);
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-undo-alt mr-2"
    }), _vm._v(_vm._s(_vm.discardDraftLabel(model)) + " ")]) : _vm._e()]);
  }), 0) : _c('div', {
    staticClass: "section-empty"
  }, [_vm._m(3), _c('div', [_c('strong', [_vm._v("Nenhum modelo do editor aqui")]), _c('small', [_vm._v(_vm._s(_vm.search ? "Tente outra busca." : "Comece criando uma nova etiqueta visual."))])]), !_vm.search ? _c('button', {
    staticClass: "btn btn-sm btn-primary font-weight-bold",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.openCreateModal();
      }
    }
  }, [_vm._v(" Criar primeira etiqueta ")]) : _vm._e()])]) : _vm._e(), _vm.showLegacySection ? _c('div', {
    staticClass: "catalog-section legacy-section"
  }, [_c('div', {
    staticClass: "section-heading"
  }, [_vm._m(4), _c('span', [_vm._v(_vm._s(_vm.filteredLegacy.length) + " encontrado" + _vm._s(_vm.filteredLegacy.length === 1 ? "" : "s"))])]), _vm.filteredLegacy.length ? _c('div', {
    staticClass: "legacy-list"
  }, _vm._l(_vm.filteredLegacy, function (row) {
    return _c('article', {
      key: row.codigo_legado,
      staticClass: "legacy-row"
    }, [_vm._m(5, true), _c('div', {
      staticClass: "legacy-main"
    }, [_c('div', {
      staticClass: "d-flex align-items-center flex-wrap"
    }, [_c('h6', [_vm._v(_vm._s(row.nome))]), _c('span', {
      staticClass: "legacy-code"
    }, [_vm._v(_vm._s(row.codigo_legado))]), _c('span', {
      class: ['state-pill ml-2', _vm.stateClass(row.estado)]
    }, [_c('i'), _vm._v(_vm._s(_vm.stateLabel(row.estado)))])]), _c('p', [_vm._v(_vm._s(row.descricao))]), row.variantes && row.variantes.length ? _c('div', {
      staticClass: "legacy-variants"
    }, _vm._l(row.variantes, function (variant) {
      return _c('div', {
        key: variant.uuid,
        staticClass: "legacy-variant"
      }, [_c('button', {
        attrs: {
          "type": "button"
        },
        on: {
          "click": function click($event) {
            return _vm.editModel(variant);
          }
        }
      }, [_c('i', {
        class: variant.tem_publicacao ? 'fas fa-check-circle' : 'far fa-save'
      }), _c('span', [_vm._v(_vm._s(_vm.scopeLabel(variant)))]), _c('small', [_vm._v(_vm._s(variant.tem_publicacao ? "v".concat(variant.versao_publicada, " em uso") : "rascunho v".concat(variant.versao_rascunho)))])]), variant.tem_rascunho ? _c('button', {
        staticClass: "discard-variant",
        attrs: {
          "type": "button",
          "title": _vm.discardDraftLabel(variant),
          "aria-label": _vm.discardDraftLabel(variant),
          "disabled": _vm.discardingUuid === variant.uuid
        },
        on: {
          "click": function click($event) {
            return _vm.discardDraft(variant);
          }
        }
      }, [_c('i', {
        staticClass: "fas fa-undo-alt mr-1"
      }), _vm._v("Cancelar rascunho ")]) : _vm._e()]);
    }), 0) : _vm._e()]), _c('div', {
      staticClass: "legacy-actions"
    }, [row.modelo ? _c('button', {
      staticClass: "btn btn-sm btn-primary font-weight-bold",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.editModel(row.modelo);
        }
      }
    }, [_vm._v(" Abrir editor ")]) : _vm._e(), _c('button', {
      class: row.modelo ? 'btn btn-sm btn-light-primary font-weight-bold mt-2' : 'btn btn-sm btn-outline-primary font-weight-bold',
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.openLegacyModal(row);
        }
      }
    }, [_vm._v(" " + _vm._s(row.modelo ? "Outro escopo" : "Criar versão editável") + " ")]), row.modelo && row.modelo.tem_rascunho ? _c('button', {
      staticClass: "btn btn-sm btn-light-danger font-weight-bold mt-2",
      attrs: {
        "type": "button",
        "disabled": _vm.discardingUuid === row.modelo.uuid
      },
      on: {
        "click": function click($event) {
          return _vm.discardDraft(row.modelo);
        }
      }
    }, [_vm._v(" " + _vm._s(_vm.discardDraftLabel(row.modelo)) + " ")]) : _vm._e()])]);
  }), 0) : _c('div', {
    staticClass: "section-empty"
  }, [_vm._m(6), _vm._m(7)])]) : _vm._e()])], _c('b-modal', {
    attrs: {
      "id": "etiqueta-create-modal",
      "size": "lg",
      "centered": "",
      "hide-footer": "",
      "no-close-on-backdrop": ""
    },
    on: {
      "hidden": _vm.resetModal
    },
    scopedSlots: _vm._u([{
      key: "modal-title",
      fn: function fn() {
        return [_c('div', {
          staticClass: "modal-title-with-icon"
        }, [_c('span', [_c('i', {
          class: _vm.modalMode === 'legacy' ? 'fas fa-shield-alt' : 'fas fa-plus'
        })]), _c('div', [_c('strong', [_vm._v(_vm._s(_vm.modalMode === "legacy" ? "Criar versão editável" : "Nova etiqueta"))]), _c('small', [_vm._v(_vm._s(_vm.modalMode === "legacy" ? _vm.selectedLegacyName : "Comece por um formato pronto"))])])])];
      },
      proxy: true
    }])
  }, [_vm.modalMode === 'legacy' ? _c('div', {
    staticClass: "modal-safety-note"
  }, [_c('i', {
    staticClass: "fas fa-lock"
  }), _c('div', [_c('strong', [_vm._v("O modelo original seguirá em uso")]), _c('span', [_vm._v("Esta ação cria somente um rascunho editável. Nada muda até a publicação.")])])]) : [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-7 form-group"
  }, [_c('label', [_vm._v("Nome do modelo "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: _vm.form.name,
      expression: "form.name",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.submitted && !_vm.form.name
    },
    attrs: {
      "type": "text",
      "maxlength": "120",
      "placeholder": "Ex.: Preço promocional 50 × 30",
      "autofocus": ""
    },
    domProps: {
      "value": _vm.form.name
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "name", $event.target.value.trim());
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  }), _c('div', {
    staticClass: "invalid-feedback"
  }, [_vm._v(" Informe um nome para identificar o modelo. ")])]), _c('div', {
    staticClass: "col-md-5 form-group"
  }, [_c('label', [_vm._v("Descrição "), _c('span', {
    staticClass: "text-muted font-weight-normal"
  }, [_vm._v("(opcional)")])]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: _vm.form.description,
      expression: "form.description",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "255",
      "placeholder": "Onde e quando é usada"
    },
    domProps: {
      "value": _vm.form.description
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "description", $event.target.value.trim());
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  })])]), _c('label', {
    staticClass: "d-block mb-2"
  }, [_vm._v("Formato inicial")]), _c('div', {
    staticClass: "preset-grid mb-5"
  }, _vm._l(_vm.presets, function (preset) {
    return _c('button', {
      key: preset.value,
      class: ['preset-card', {
        selected: _vm.form.preset === preset.value
      }],
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          _vm.form.preset = preset.value;
        }
      }
    }, [_c('span', {
      staticClass: "preset-radio"
    }, [_c('i')]), _c('span', [_c('strong', [_vm._v(_vm._s(preset.label))]), _c('small', [_vm._v(_vm._s(preset.description))])])]);
  }), 0)], _c('div', {
    staticClass: "scope-area"
  }, [_c('label', {
    staticClass: "d-block mb-2"
  }, [_vm._v("Onde este modelo ficará disponível?")]), _c('div', {
    staticClass: "scope-grid"
  }, [_c('button', {
    class: ['scope-card', {
      selected: _vm.form.scope === 'global'
    }],
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.selectScope('global');
      }
    }
  }, [_c('span', {
    staticClass: "scope-icon"
  }, [_c('i', {
    staticClass: "fas fa-globe-americas"
  })]), _c('span', [_c('strong', [_vm._v("Todas as empresas")]), _c('small', [_vm._v("Disponível globalmente após publicar")])]), _c('i', {
    staticClass: "fas fa-check-circle scope-check"
  })]), _c('button', {
    class: ['scope-card', {
      selected: _vm.form.scope === 'empresa'
    }],
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.selectScope('empresa');
      }
    }
  }, [_c('span', {
    staticClass: "scope-icon"
  }, [_c('i', {
    staticClass: "fas fa-building"
  })]), _c('span', [_c('strong', [_vm._v("Uma empresa")]), _c('small', [_vm._v("Modelo exclusivo para um cliente")])]), _c('i', {
    staticClass: "fas fa-check-circle scope-check"
  })])]), _vm.form.scope === 'empresa' ? _c('div', {
    staticClass: "company-picker"
  }, [_c('label', [_vm._v("Empresa que receberá o modelo")]), _vm.selectedCompany ? _c('div', {
    staticClass: "selected-company"
  }, [_c('span', [_c('i', {
    staticClass: "fas fa-building"
  })]), _c('div', [_c('strong', [_vm._v(_vm._s(_vm.companyName(_vm.selectedCompany)))]), _c('small', [_vm._v(_vm._s(_vm.selectedCompany.cnpj_cpf || "C\xF3digo ".concat(_vm.selectedCompany.id_empresa)))])]), _c('button', {
    staticClass: "btn btn-xs btn-icon btn-light",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.clearCompany
    }
  }, [_c('i', {
    staticClass: "fas fa-times"
  })])]) : [_c('div', {
    staticClass: "input-icon"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: _vm.companySearch,
      expression: "companySearch",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Busque por nome ou CNPJ"
    },
    domProps: {
      "value": _vm.companySearch
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) return;
        _vm.companySearch = $event.target.value.trim();
      }, _vm.scheduleCompanySearch],
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  }), _c('span', [_c('i', {
    class: _vm.searchingCompanies ? 'spinner spinner-sm spinner-primary' : 'flaticon2-search-1 text-muted'
  })])]), _vm.companies.length ? _c('div', {
    staticClass: "company-results"
  }, _vm._l(_vm.companies, function (company) {
    return _c('button', {
      key: company.id_empresa,
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.chooseCompany(company);
        }
      }
    }, [_c('span', [_c('strong', [_vm._v(_vm._s(_vm.companyName(company)))]), _c('small', [_vm._v(_vm._s(company.cnpj_cpf || "C\xF3digo ".concat(company.id_empresa)))])]), _c('i', {
      staticClass: "fas fa-chevron-right"
    })]);
  }), 0) : _vm.companySearch && !_vm.searchingCompanies ? _c('small', {
    staticClass: "text-muted d-block mt-2"
  }, [_vm._v("Nenhuma empresa encontrada.")]) : _vm._e()], _vm.submitted && !_vm.form.companyId ? _c('div', {
    staticClass: "text-danger font-size-xs mt-2"
  }, [_vm._v(" Selecione a empresa. ")]) : _vm._e()], 2) : _vm._e()]), _c('div', {
    staticClass: "modal-actions"
  }, [_c('button', {
    staticClass: "btn btn-light font-weight-bold",
    attrs: {
      "type": "button",
      "disabled": _vm.saving
    },
    on: {
      "click": function click($event) {
        return _vm.$bvModal.hide('etiqueta-create-modal');
      }
    }
  }, [_vm._v(" Cancelar ")]), _c('button', {
    staticClass: "btn btn-primary font-weight-bold",
    class: {
      'spinner spinner-light spinner-right': _vm.saving
    },
    attrs: {
      "type": "button",
      "disabled": _vm.saving
    },
    on: {
      "click": _vm.submitModal
    }
  }, [_vm._v(" " + _vm._s(_vm.modalMode === "legacy" ? "Criar rascunho e editar" : "Criar e abrir editor") + " ")])])], 2)], 2);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('div', {
    staticClass: "d-flex align-items-center mb-1"
  }, [_c('span', {
    staticClass: "page-icon"
  }, [_c('i', {
    staticClass: "fas fa-tags"
  })]), _c('span', {
    staticClass: "page-eyebrow"
  }, [_vm._v("Ferramenta do suporte")])]), _c('h2', [_vm._v("Modelos de etiquetas")]), _c('p', [_vm._v("Crie e ajuste modelos visuais sem alterar código.")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('span', [_c('i', {
    staticClass: "flaticon2-search-1 text-muted"
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('h5', [_vm._v("Modelos do editor")]), _c('p', [_vm._v(" Modelos novos e versões já convertidas para o editor visual. ")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('span', [_c('i', {
    staticClass: "fas fa-pencil-ruler"
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('h5', [_vm._v("Catálogo legado")]), _c('p', [_vm._v(" Estes modelos permanecem no motor original até uma publicação explícita. ")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "legacy-symbol"
  }, [_c('i', {
    staticClass: "fas fa-shield-alt"
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('span', [_c('i', {
    staticClass: "fas fa-search"
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('strong', [_vm._v("Nenhum legado encontrado")]), _c('small', [_vm._v("Altere os termos da busca.")])]);
}];
export { render, staticRenderFns };